export default __webpack_public_path__ + "static/media/prometeo_payment.32541184.png";